// Product type definition
export interface Product {
  id: number;
  name: string;
  path: string;
  image: string;  // keep as-is
  description: string;
  specifications: string[];
  applications: string[];
  features: string[];
  packaging?: string[];
  delivery?: {
    availableForms?: string;
    supplyFocus?: string;
    consistency?: string;
    minimumOrderQuantity?: string;
    pricing?: string;
    deliveryTime?: string;
    storage?: string;
  };
  physicalfeatures: string[];
}

export const productList: Product[] = [

  //1
  {
    "id": 1,
    "name": "Potassium Feldspar Powder PFP-100",
    "path": "/products/potash-feldspar-super-grade",
    "image": "/images/products/NewProductes/Potash Feldspar PFP-100.png",

    "description": "Potassium Feldspar Powder (PFP-100) is a high-grade fluxing mineral used widely in ceramics, glass, frits, glazes, paints, polymers, and welding electrodes. With high K₂O content, low impurities, excellent thermal behavior, and fine particle size (up to 500 mesh), it enhances strength, brightness, and melting performance while maintaining consistency across production batches.",

    "features": [
      "High K2O Content",
      "Low Iron & Titanium Impurities",
      "Stable Thermal Behavior",
      "High Alumina Content",
      "Uniform Particle Size Distribution: Up to 500 Mesh"
    ],

    "specifications": [
      "Excellent Fusion Properties"
    ],

    "packaging": [
      "25 kg Bags",
      "50 kg Bags",
      "1000 kg Jumbo Bags",
      "1250 kg Jumbo Bags",
      "1400 kg Jumbo Bags"
    ],

    "applications": [
      "Ceramic Industry – Used in tiles, sanitaryware, tableware, and porcelain for its fluxing and whitening properties.",
      "Glass Industry – Acts as a flux to improve clarity, strength, and workability of glass.",
      "Frits & Glaze Industry – Essential for producing glossy, smooth, and durable finishes.",
      "Paints & Coatings Industry – Adds durability, scratch resistance, and brightness to coatings.",
      "Plastic & Polymer Industry – Enhances hardness, chemical resistance, and dimensional stability.",
      "Electrode & Welding Industry – Improves melting behavior in flux formulations."
    ],

    "delivery": {
      "minimumOrderQuantity": "25 Metric Ton or higher",
      "deliveryTime": "5–15 days from order confirmation",
      "storage": "Store in dry, cool conditions for extended shelf life"
    },

    "physicalfeatures": [
      "Appearance: Fine white powder",
      "Form: Powder",
      "Color: Off-white to pure white",
      "Odor: Odorless",
      "Hardness: 6–6.5 (Mohs Scale)",
      "Melting Point: ~1250°C"
    ]
  },

  //2
  {
    "id": 2,
    "name": "Sodium Feldspar Powder SFP-100",
    "path": "/products/soda-feldspar-powder-sfp-100",
    "image": "/images/products/NewProductes/Soda Feldspar Powder.png",

    "description": "Sodium Feldspar Powder SFP-100 is a high-purity, finely-milled feldspar mineral engineered for superior glaze performance in ceramic, frit, and engobe applications. With high sodium content, low impurities, and excellent melting behavior, it ensures brilliant, defect-free glaze finishes while enhancing mechanical and thermal properties across multiple industrial applications.",

    "features": [
      "High Sodium Content",
      "Fine Mesh Size : up to 500 mesh",
      "Low Iron & Titanium Impurities",
      "Balanced Silica & Alumina Composition",
      "Excellent Vitrification Properties",
      "Chemically Stable",
      "Ideal for Precision Applications",
    ],

    "specifications": [
      "SiO2: 65–80%",
      "Al2O3: 12–22%",
      "K2O: 1–2% Min",
      "Na2O: 8.5% to 9%",
      "Fe2O3: 0.5% Max",
      "CaO: 1% Max",
      "L > 85, a < 2, b < 5",
    ],

    "applications": [
      "Glaze & Frit Industry – Enhances surface gloss, smoothness, and resistance to scratching and chemical attack.",
      "Ceramic Industry – Used in tiles, sanitaryware, tableware, and insulators for strength, whiteness, and smooth finish.",
      "Glass Industry – Acts as a flux to lower melting temperature and improve transparency and durability.",
      "Paint & Coating Industry – Improves brightness, hardness, and durability of coatings.",
      "Plastic & Polymer Industry – Serves as a filler to increase rigidity, thermal stability, and dimensional strength.",
      "Electrode Industry – Helps in coating formulations to improve thermal performance and binding strength.",     
    ],

    "packaging": [
      "Industry Focus: Ceramic Tile Industry",
      "Quality: Optimized for Superior Glaze Formulations",
      "Performance: Maximizes Production Output",
      "Supply Focus: Secure Your Supply Today"
    ],

    "delivery": {
      "availableForms": "Finely-Milled Powder",
      "supplyFocus": "Ceramic Tile and Frit Manufacturing Industries",
      "consistency": "Consistent Chemical Composition and Particle Fineness",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Competitive / On Request",
      "deliveryTime": "7–10 Days",
      "storage": "Store in a dry, cool area to prevent moisture absorption"
    },

    "physicalfeatures": [
      "Bright white appearance with smooth, fine texture",
      "Excellent consistency and flow for glaze applications",
      "Ensures uniform melting and brilliant surface finish"
    ]
  },

  //3
  {
    "id": 3,
    "name": "Quartz Lumps",
    "path": "/products/quartz-lumps",
    "image": "/images/products/NewProductes/meticulously selected Quartz Lumps.png",

    "description": "High-purity Quartz Lumps (SiO₂ 98.5–99.8%) are meticulously selected to ensure exceptional chemical inertness, superior hardness, and thermal stability. These lumps serve as a critical raw material across high-tech, glass, refractory, construction, and energy industries where ultra-low impurities and reliable material integrity are non-negotiable.",

    "features": [
      "High Purity SiO₂",
      "Low Iron & Impurities",
      "High Hardness",
      "Thermal Stability",
      "Chemically Inert",
      "Versatile Particle Size",
    ],

    "specifications": [
      "SiO₂: 98.5–99.8%",
      "Al₂O₃: 0.2–0.5%",
      "Fe₂O₃: 0.03–0.1% (Max)",
      "TiO₂: 0.05% (Max)",
      "CaO: 0.1% (Max)",
      "MgO: 0.1% (Max)",
      "Loss on Ignition (LOI): <0.5%",
      "Whiteness (L): >90",
      "a: <1.0",
      "b: <2.0",
    ],

    "applications": [
      "Ceramic Industry – Used in tiles, sanitaryware, porcelain, and insulators for strength, whiteness, and thermal stability.",
      "Glass Industry – Provides high-purity silica for glass, fiberglass, and specialty glass applications.",
      "Foundry & Metallurgical Industry – Acts as a refractory material, sand, or flux in metal casting and steelmaking.",
      "Paint & Coating Industry – Used as a filler to improve hardness, brightness, and durability of paints and coatings.",
      "Plastic & Polymer Industry – Functions as a reinforcing filler to enhance rigidity, strength, and thermal stability.",
      "Electronics & Semiconductor Industry – High-purity quartz is used in silicon wafers and other electronic components.",
      "Construction Industry – Serves as sand, aggregate, or decorative stone in concrete and building materials.",
      "Chemical Industry – Raw material for producing silicon compounds, silicates, and other chemical products.",
      "Abrasive Industry – Used in sandpapers, grinding wheels, and polishing materials.",
      "Refractory Industry – Acts as a heat-resistant material for furnace linings and kilns.",
      "Water Filtration & Treatment Industry – Quartz sand is used in filters for water purification.",
    ],

    "packaging": [
      "Material Form: Lumps",
      "Quality Control: Meticulously Selected",
      "Goal: Prevent Production Stalls",
      "Performance: Guarantees Material Certainty"
    ],

    "delivery": {
      "availableForms": "Lumps (Transparent to Milky White)",
      "supplyFocus": "Glass, Electronics, Refractories, and Energy Industries",
      "consistency": "High SiO₂ Purity and Chemical Inertness",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Competitive / On Request",
      "deliveryTime": "7–10 Days",
      "storage": "Store in a dry, covered area to maintain purity and prevent contamination"
    },

    "physicalfeatures": [
      "Transparent to milky white appearance with high brightness",
      "Hardness of 7 on the Mohs scale for superior durability",
      "Chemically inert structure for maximum process stability",
      "Low impurity content ensures high-performance industrial outputs"
    ]
  },

  //4
  {
    "id": 4,
    "name": "Dolomite Stone Micron Powder",
    "path": "/products/dolomite-powder",
    "image": "/images/products/NewProductes/DolomitePowder.png",

    "description": "R.L. Minerals Mining offers premium, high-purity micronized Dolomite Powder designed for industrial applications requiring superior whiteness, consistent particle size, and exceptional dispersion. With controlled composition, low impurities, and high brightness, this mineral serves as a versatile, cost-effective filler across construction, plastics, coatings, ceramics, and specialty sectors.",

    "features": [
      "High Purity Composition",
      "Ultra-Fine Micronized Particles: up to 1000 mesh",
      "High Whiteness",
      "Excellent Weather & Heat Resistance",
      "Low Moisture & Impurity Content",
      "Improves Surface Finish",
      "Versatile Industrial Application",     
    ],

    "specifications": [
      "CaCO₃: 48–54%",
      "MgCO₃: 34–40%",
      "SiO₂: 1.5% (Max)",
      "Fe₂O₃: 0.3% (Max)",
      "Al₂O₃: 0.2% (Max)",
      "Loss on Ignition (LOI): 44–46%",
      "Whiteness (L): >90",
      "a: <1.5",
      "b: <3",
    ],

    "applications": [
      "Paint & Coating Industry – Used as a filler and extender to improve opacity, smoothness, and durability.",
      "Plastic & Polymer Industry – Enhances strength, rigidity, and surface finish while reducing shrinkage.",
      "Rubber Industry – Improves elasticity, strength, and resistance to aging.",
      "Ceramic Industry – Acts as a fluxing agent and increases mechanical strength and whiteness.",
      "Paper Industry – Provides brightness, opacity, and smoothness to coated papers.",
      "Cosmetic Industry – Used as a natural filler for smooth texture and high brightness.",
      "Detergent Industry – Serves as a whitening and buffering agent in detergent formulations.",
    ],

    "packaging": [
      "Supplier: R.L. Minerals Mining",
      "Supply Reliability: High-Performance, Reliable Supply",
      "Market Focus: Importers & Global Leaders",
      "Quality Assurance: Superior Quality Control"
    ],

    "delivery": {
      "availableForms": "Micronized Fine Powder (200# / 300# / 400#)",
      "supplyFocus": "Construction, Paint, Ceramic, and Industrial Applications",
      "consistency": "Guaranteed 95+% Whiteness with Controlled Particle Size",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Competitive / On Request",
      "deliveryTime": "7–10 Days",
      "storage": "Store in a dry and cool area; avoid moisture exposure to maintain flow and purity"
    },

    "physicalfeatures": [
      "Pure white to off-white fine powder",
      "Highly micronized for consistent fineness",
      "Excellent whiteness and dispersion quality",
      "Low moisture and controlled particle size"
    ]
  },

  //5
  {
    id: 5,
    name: "Calcite Micron Powder",
    path: "/products/calcite-powder",
    image: "/images/products/NewProductes/Calcite Micron Powder.png",
    description: "Calcite Micron Powder isn't just ground rock-it's the ultimate, cost-effective performance booster for a host of industries! This high-purity Calcium Carbonate (CaCO₃), micronized to an ultra-fine level (down to 1000 mesh), delivers superior qualities others can't match.",
    specifications: [
      "CaCO₃: 96-99%",
      "MgCO₃: 0.5–1.5%",
      "SiO₂: 0.5% (Max)",
      "Fe₂O₃: 0.1% (Max)",
      "Al₂O₃: 0.1% (Max)",
      "Smooth, Free-Flowing Texture",
      "Loss on Ignition (LOI): 43–44%"
    ],
    applications: [
      "Plastic & Polymer Industry – Used as a filler to improve stiffness, brightness, and dimensional stability in PVC, PP, and PE products.",
      "Paints & Coatings Industry – Enhances opacity, brightness, and dispersion while reducing production costs.",
      "Rubber Industry – Increases tensile strength, smoothness, and resistance to deformation.",
      "Paper Industry – Serves as a coating and filler pigment for better whiteness, smoothness, and printability.",
      "Adhesives & Sealants Industry – Provides consistency, strength, and improved bonding properties.",
      "Cement & Construction Industry – Used in putty, wall finishes, and decorative plasters for whiteness and smooth texture.",
      "Cosmetic Industry – Acts as a natural filler and opacity enhancer in face powders and cosmetic formulations.",
      "Detergent Industry – Used as a mild abrasive and whitening agent in powder detergents.",


    ],
    features: [
      "Brilliant Whiteness & High Opacity",
      "Smooth, Free-Flowing Texture",
      "Non-Toxic & Chemically Stable",
      "High Purity Performance Booster",
    ],
    physicalfeatures: [
      "Whiteness (L): >95",
      "a: <1.0",
      "b: <2.0",
      "Form: Micronized Fine Powder",
      "Color: Pure White to Snow White",
      "Moisture: <0.3%",
      "Hardness (Mohs): 3",
      "Specific Gravity: 2.7",
      "Particle Size: 2–25 Micron (D97)",
      "Mesh Size: 400# to 2500#"
    ],
  },

  //6
  {
    "id": 6,
    "name": "Dolomite Stone Lumps",
    "path": "/products/dolomite-paint-putty-coatings",
    "image": "/images/products/NewProductes/DolomiteChips.png",

    "description": "High-purity Dolomite (CaMg(CO₃)₂) engineered specifically for advanced paint, putty, and coating formulations. With customizable sizing-from coarse chips to fine powders-this mineral serves as a reliable, cost-effective filler that enhances brightness, opacity, durability, and surface performance across premium manufacturing applications.",

    "features": [
      "Uniform Grain Size Distribution : 30*80, 24*52, 16*32,4MM, 3MM, 2MM, 1MM",
      "Excellent Whiteness & Brightness",
      "High Purity Calcium Magnesium Carbonate",
      "High Strength & Density",
      "Low Iron & Silica Content",
      "Good Fluxing Properties",
      "Chemically Stable & Non-Reactive",
    ],

    "specifications": [
      "CaCO₃: 48–54%",
      "MgCO₃: 34–40%",
      "SiO₂: 1.5% (Max)",
      "Fe₂O₃: 0.3% (Max)",
      "Al₂O₃: 0.2% (Max)",
      "Loss on Ignition (LOI): 44–46%",
      "Whiteness (L): >90",
      "a: <1.5",
      "b: <3",
      
    ],

    "applications": [
      "Ceramic Industry – Used as a fluxing and filler material in tiles, sanitaryware, and porcelain bodies.",
      "Glass Industry – Acts as a stabilizer and flux to improve melting behavior, clarity, and durability.",
      "Steel & Metallurgical Industry – Used as a flux and refractory material in steelmaking.",
      "Paint & Coating Industry – Provides brightness, opacity, and smooth texture.",
      "Plastic & Rubber Industry – Enhances strength, rigidity, and dimensional stability in polymer products.",
      "Construction Industry – Serves as aggregate or filler in concrete, road building, and decorative stone applications.",
      "Detergent Industry – Functions as a whitening agent and mild abrasive in cleaning formulations.",
      "Agricultural Industry – Used as Dolomitic Lime to correct acidic soils and provide calcium and magnesium nutrients.",
    ],

    "packaging": [
      "Quality Promise: Consistent Quality and Reliable Supply",
      "Benefit: Cost-Effective Alternative to Expensive Pigments",
      "Sizing: Customizable to Guarantee Optimal Dispersion and Texture",
      "Goal: Elevate the Quality of Your Entire Product Line"
    ],

    "delivery": {
      "availableForms": "Chips (Coarse / Granular) and Fine Powder (Customizable)",
      "supplyFocus": "Paint, Putty, and Coating Industries",
      "consistency": "Guaranteed Purity, Whiteness, and Custom Sizing",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Competitive / On Request",
      "deliveryTime": "7–10 Days",
      "storage": "Store in a dry, shaded environment to maintain whiteness and prevent moisture absorption"
    },

    "physicalfeatures": [
      "White to off-white appearance with controlled particle sizing",
      "Hardness 3.5–4 (Mohs) ensuring strength and durability",
      "Enhances brightness, whiteness, and coating smoothness",
      "High-purity calcium-magnesium composition for consistent performance"
    ]
  },

  //7
  {
    "id": 7,
    "name": "Potassium Feldspar Powder PFP-110",
    "path": "/products/potash-feldspar-pfp-110",
    "image": "/images/products/NewProductes/Potash Feldspar Powder.png",

    "description": "Potassium Feldspar Powder PFP-110 is a super-grade fluxing mineral known for its ultra-low iron content, high K₂O concentration, and superior vitrification performance. It offers exceptional brightness, strength, and chemical stability, making it ideal for ceramics, glass, frits, glazes, polymers, and welding electrode applications. With consistent particle size distribution (up to 500 mesh) and high purity, it ensures reliable production performance across global industries.",

    "features": [
      "Ultra-Low Fe2O3 Content",
      "High K2O Concentration",
      "Maximum Vitrification",
      "Guaranteed Brilliance & Strength",
      "High Brightness & Purity",
      "Uniform Particle Size Distribution: Up to 500 Mesh",
    ],

    "specifications": [
      "K₂O: <10%",
      "Na₂O: 2%",
      "Fe₂O₃: 0.10%",
      "CaO: 0.05%"
    ],

    "packaging": [
      "25 kg Bags",
      "50 kg Bags",
      "1000/1250/1400 kg Jumbo Bags",
      "1250 kg Jumbo Bags",
      "1400 kg Jumbo Bags"
    ],

    "applications": [
      "Ceramic Industry – Used in tiles, sanitaryware, tableware, and porcelain bodies for fluxing, strength, and whiteness.",
      "Glass Industry – Acts as a flux to lower melting temperature, improving clarity and hardness of glass.",
      "Frits & Glaze Industry – Key raw material for glossy, smooth, and durable surface finishes.",
      "Paints & Coatings Industry – Enhances brightness, scratch resistance, and chemical durability.",
      "Plastic & Polymer Industry – Used as a reinforcing filler to improve rigidity and thermal resistance.",
      "Abrasive Industry – Provides hardness and stability in manufacturing of polishing compounds and abrasives.",
      "Electrode & Welding Flux Industry – Improves melting behavior and slag fluidity."
    ],

    "delivery": {
      "availableForms": "Lumps, Powder (Various Mesh Sizes)",
      "supplyFocus": "Stable Global Supply",
      "pricing": "Competitive Pricing",
      "consistency": "Certified Chemical Consistency",
      "minimumOrderQuantity": "25 Metric Ton or higher",
      "deliveryTime": "5–15 days from order confirmation",
      "storage": "Store in dry, cool conditions for extended shelf life"
    },

    "physicalfeatures": [
      "Appearance: Fine white to off-white powder",
      "Form: Powder / Lumps",
      "Color: Pure white (ultra-low iron)",
      "Odor: Odorless",
      "Hardness: 6–6.5 (Mohs Scale)",
      "Melting Point: ~1250°C"
    ]
  },

  //8
  {
    "id": 8,
    "name": "Potassium Feldspar Powder PFP-90",
    "path": "/products/potash-feldspar-frit-grade",
    "image": "/images/products/NewProductes/Potash Feldspar Powder 200.png",

    "description": "Potassium Feldspar Powder PFP-90 (200#) is a special-use, ultra-fine, bright white fluxing mineral engineered specifically for frit, glaze, ceramic, and glass applications. It offers excellent melting behavior, high alumina content, low iron impurities, and consistent particle distribution up to 500 mesh-ensuring brilliant, durable, and defect-free surfaces in industrial applications.",

    "features": [
      "Ultra-Fine Particle Size : up to 500 mesh",
      "Bright White Color",
      "Excellent Fusion & Melting Properties",
      "Low Iron & Titanium Impurities",
      "High Alumina Content",
      "Consistent Quality & Purity",
    ],

    "specifications": [
      "K2O: <9%",
      "Na2O: 2%",
      "Fe2O3: 0.15%",
      "CaO: 0.10%"
    ],

    "applications": [
      "Ceramic Industry – Widely used in tiles, sanitaryware, tableware, and porcelain for fluxing, strength, and whiteness.",
      "Glass Industry – Acts as a fluxing agent to lower melting point and enhance transparency and durability.",
      "Frits & Glaze Industry – Essential for producing glossy, smooth, and defect-free glaze surfaces.",
      "Paints & Coatings Industry – Provides brightness, hardness, and scratch resistance in high-quality coatings.",
      "Plastic & Polymer Industry – Used as a filler to increase stiffness, chemical resistance, and dimensional stability.",
      "Electrode & Welding Industry – Helps improve slag fluidity and uniform melting behavior.",
      "Abrasives Industry – Used for polishing and grinding material manufacturing due to its hardness and stability."
    ],

    "packaging": [
      "Grade: Special Use Grade",
      "Form: Ultra-Fine Powder",
      "Stability: Guaranteed Chemical Stability",
      "Quality: High-Quality Glass-Phase Formation"
    ],

    "delivery": {
      "availableForms": "Ultra-Fine Powder",
      "supplyFocus": "Frit and Ceramic Industries",
      "consistency": "Guaranteed Chemical Stability",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Competitive / On Request",
      "deliveryTime": "7-10 Days",
      "storage": "Store in a dry, cool area away from moisture"
    },

    "physicalfeatures": [
      "Bright white color",
      "Fine and uniform particle distribution",
      "Excellent vitrification at low temperatures"
    ]
  },

  //9
  {
    "id": 9,
    "name": "Potassium Feldspar Powder PFP-90",
    "path": "/products/potash-feldspar-sanitary-ware",
    "image": "/images/products/NewProductes/Potash Feldspar Powdersanitary ware.png",

    "description": "Potassium Feldspar Powder PFP-90 (Sanitary Ware Grade) is a bright white, ultra-fine, sodium-rich fluxing mineral engineered specifically for ceramic sanitaryware applications. Its moderate potash content, ultra-low iron impurities, and stable chemical composition ensure flawless whiteness, high fired strength, and smooth vitrification in premium ceramic bodies such as basins, toilets, and pedestals.",

    "features": [
      "Moderate Potash Content",
      "Sodium-Rich Composition",
      "Ultra-Low Iron Content",
      "Low Calcium Content",
      "Fine Particle Size: up to 500 mesh",
      "Stable Chemical Composition",
      "Excellent Fusion & Thermal Stability",
    ],

    "specifications": [
      "K2O: <6%",
      "Na2O: 2%",
      "Fe2O3: 0.15%",
      "CaO: 0.10%"
    ],

    "applications": [
      "Ceramic Industry – Widely used in sanitaryware, wall tiles, floor tiles, and porcelain as a fluxing agent to enhance whiteness, strength, and vitrification.",
      "Glass Industry – Improves transparency, durability, and thermal stability while reducing melting temperature.",
      "Frits & Glaze Industry – Essential for glossy, smooth, and defect-free glaze surfaces.",
      "Paints & Coatings Industry – Enhances brightness, hardness, and chemical resistance.",
      "Plastic & Polymer Industry – Used as a filler to improve rigidity and dimensional stability.",
      "Electrode & Welding Industry – Enhances slag fluidity and melting performancein flux formulations.",
      "Abrasive Industry – Used in polishing and grinding materials due to hardness and consistency."
    ],

    "packaging": [
      "Grade: Sanitary Ware Grade",
      "Form: Ultra-Fine Powder",
      "Purity: Bright White Mineral",
      "Consistency: Consistent Chemical Composition"
    ],

    "delivery": {
      "availableForms": "Ultra-Fine Powder",
      "supplyFocus": "Sanitary Ware & Ceramic Industries",
      "consistency": "Consistent Chemical Composition",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Competitive / On Request",
      "deliveryTime": "7-10 Days",
      "storage": "Store in a dry, cool area away from moisture"
    },

    "physicalfeatures": [
      "Bright white mineral appearance",
      "Low porosity and high fired strength",
      "Provides smooth vitrification and durable body formation"
    ]
  },

  //10
  {
    "id": 10,
    "name": "Potassium Feldspar Lumps",
    "path": "/products/special-white-lumps",
    "image": "/images/products/NewProductes/Special White Lumps.png",

    "description": "Potassium Feldspar Special White Lumps are high-purity, high-whiteness mineral lumps engineered for industries that demand exceptional color consistency, superior fluxing behavior, and high thermal stability. With excellent whiteness after firing and low titanium and iron impurities, these lumps are ideal for premium ceramic, vitrified tile, glass, cosmetic, and paint applications.",

    "features": [
      "Superior Whiteness After Firing",
      "High Potassium Content",
      "High Alumina Content",
      "Low Iron & Titanium Oxides",
      "Excellent Thermal Stability",
      "High Purity Natural Mineral",
    ],

    "specifications": [
      "K₂O: 10–12%",
      "Na₂O: 2–3%",
      "CaO: <0.15%",
      "Whiteness After Firing: 85–90%"
    ],

    "applications": [
      "Ceramic Industry – Used in sanitaryware, wall tiles, floor tiles, and porcelain for excellent fluxing and whitening properties.",
      "Glass Industry – Acts as a key fluxing agent enhancing transparency, durability, and strength.",
      "Frits & Glaze Industry – Essential for glossy, smooth, and defect-free glaze formation.",
      "Vitrified Tile Industry – Ensures superior vitrification, strength, and clean surface finish.",
      "Paints & Coatings Industry – Enhances brightness, hardness, and chemical resistance.",
      "Plastic & Polymer Industry – Improves stiffness, thermal resistance, and dimensional stability.",
      "Abrasive Industry – Used in polishing and grinding materials for its hardness and consistency.",
      "Electrode & Welding Industry – Enhances slag fluidity and melting behavior.",
    ],

    "packaging": [
      "Consistency: Guaranteed Batch-to-Batch Consistency",
      "Application Need: Non-Fading, Reliable Results",
      "Valued For: Powerful Fluxing & High Whiteness",
      "Grade: Special White Lumps"
    ],

    "delivery": {
      "availableForms": "High-Grade Lumps",
      "supplyFocus": "Ceramic, Cosmetic & Paint Industries",
      "consistency": "Guaranteed Batch-to-Batch Consistency",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Competitive / On Request",
      "deliveryTime": "7-10 Days",
      "storage": "Store in a dry and shaded area to maintain purity"
    },

    "physicalfeatures": [
      "Bright white color with high purity",
      "Excellent fluxing properties for low-temperature melting",
      "Retains color stability even after thinner application"
    ]
  },

  //11
  {
    "id": 11,
    "name": "Potassium Feldspar Lumps P1",
    "path": "/products/p1-potash-lumps",
    "image": "/images/products/NewProductes/Our P1 Potash Lumps.png",

    "description": "P1 Potash Lumps are premium-grade feldspar lumps featuring exceptionally low iron content, high potassium and alumina levels, and outstanding thermal stability. Designed for applications requiring brilliant pure-white firing (1180°C), these lumps deliver unmatched clarity, superior fluxing power, and reliable consistency for high-end ceramic, glass, glaze, and welding electrode industries.",

    "features": [
      "Superior Whiteness After Firing",
      "High Potassium Content",
      "High Alumina Content",
      "Low Iron & Titanium Oxides",
      "Excellent Thermal Stability",
      "High Purity Natural Mineral",
    ],

    "specifications": [
      "K2O: <10%",
      "Na2O: 2%",
      "Fe2O3: 0.10%",
      "CaO: 0.05%",
      
    ],

    "applications": [
      "Ceramic Industry – Used in tiles, sanitaryware, tableware, and insulators for its fluxing and whitening properties.",
      "Glass Industry – Acts as a flux to reduce melting temperature and improve clarity and strength.",
      "Glaze & Frit Industry – Enhances surface gloss, smoothness, and durability of glazes.",
      "Paint & Coating Industry – Improves hardness, brightness, and chemical resistance.",
      "Plastic & Polymer Industry – Used as a functional filler to enhance strength and durability.",
      "Electrode Industry – Helps in bonding and stability of electrode coatings.",
    ],

    "packaging": [
      "Grade: P1 Potash Lumps",
      "Consistency: Guaranteed Whiteness",
      "Special Use: Consistent Arc Stability",
      "Quality: Unrivalled Performance"
    ],

    "delivery": {
      "availableForms": "Lumps (High-Purity Grade)",
      "supplyFocus": "Glass, Ceramic, and Welding Industries",
      "consistency": "Guaranteed Whiteness and Batch Stability",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Competitive / On Request",
      "deliveryTime": "7-10 Days",
      "storage": "Store in a clean, dry environment to preserve whiteness and purity"
    },

    "physicalfeatures": [
      "Exceptionally low iron content for high clarity",
      "Brilliant pure white appearance after firing at 1180°C",
      "Maintains thermal and chemical stability under heat"
    ]
  },

  //12
  {
    "id": 12,
    "name": "Potassium Feldspar Chips",
    "path": "/products/potash-feldspar-chips",
    "image": "/images/products/NewProductes/high-purity Potash Feldspar Chips.png",

    "description": "High-purity Potassium Feldspar Chips (0–5 mm) designed for construction, ceramics, tiles, and vitrification industries. These precision-sized chips offer high potassium content, uniform grain size, excellent thermal stability, and exceptional chemical resistance-making them a critical additive for cement, concrete, glazed vitrified tiles (GVT), and ceramic flux applications.",

    "features": [
      "High Potassium Content",
      "Low Iron & Titanium Impurities",
      "Uniform Grain Size (0–5 mm)",     
      "High Alumina & Silica Ratio",
      "Excellent Thermal Stability",
      "Chemically Inert",
      "Ideal for Industrial Applications"
    ],

    "specifications": [
      "K2O: 9%",
      "Na2O: 2%",
      "Fe2O3: 0.2%",
      "CaO: 0.4%",      
    ],

    "applications": [
      "Ceramic Industry – Used in tiles, sanitaryware, and porcelain bodies for strength and whiteness.",
      "Glass Industry – Acts as a flux to lower melting temperatures and enhance transparency.",
      "Glaze & Frit Industry – Enhances gloss, surface smoothness, and hardness of glazes.",
      "Electrode Industry – Provides bonding strength and stability in welding coating formulations.",
      "Paint & Coating Industry – Improves durability, brightness, and chemical resistance.",
      "Plastic & Polymer Industry – Enhances mechanical strength and reduces shrinkage.",
      
    ],

    "packaging": [
      "Material Quality: High-Purity",
      "Ceramic Result: Unmatched Fired Strength & Zero Porosity",
      "Import Focus: Used by importers and cement mixers",
      "Guarantee: Superior Result Every Time"
    ],

    "delivery": {
      "availableForms": "Chips (0–5mm)",
      "supplyFocus": "Construction, Ceramic & Tile Industries",
      "consistency": "Uniform Chip Size and High Purity",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Competitive / On Request",
      "deliveryTime": "7–10 Days",
      "storage": "Store in a dry area; avoid moisture exposure to retain integrity"
    },

    "physicalfeatures": [
      "High-purity white chips with uniform size distribution",
      "High alkali content for superior fluxing performance",
      "Excellent mechanical and chemical resistance in composites"
    ]
  },

  //13
  {
    "id": 13,
    "name": "Sodium Feldspar Powder SFP-90",
    "path": "/products/soda-feldspar-powder",
    "image": "/images/products/NewProductes/Soda Feldspar Powder 200.png",

    "description": "Sodium Feldspar Powder SFP-90 is a high-purity, finely-milled feldspar mineral with enhanced Na₂O content, engineered for premium glaze, frit, ceramic, and tile applications. With superior vitrification properties, balanced silica–alumina composition, and low impurities, it ensures bright, smooth, defect-free glaze finishes with reliable melting performance.",

    "features": [
      "High Sodium Content",
      "Low Iron & Titanium Impurities",
      "High Silica & Alumina Composition",
      "Excellent Melting Behavior",
      "Fine Particle Size Distribution : up to 500 mesh",
      "Chemically Stable",
      "Versatile Industrial Us",
    ],

    "specifications": [
      "SiO2: 65–80%",
      "Al2O3: 12–22%",
      "K2O: 1–2% Min",
      "Na2O: >9% Above",
      "Fe2O3: 0.5% Max",
      "CaO: 1% Max",
      "L > 85, a < 2, b < 5",
      
    ],

    "applications": [
      "Glaze & Frit Industry – Enhances surface gloss, smoothness, and resistance to scratching and chemical attack.",
      "Ceramic Industry – Used in tiles, sanitaryware, tableware, and insulators for strength, whiteness, and smooth finish.",
      "Glass Industry – Acts as a flux to lower melting temperature and improve transparency and durability.",
      "Paint & Coating Industry – Improves brightness, hardness, and durability.",
      "Plastic & Polymer Industry – Serves as a filler to increase rigidity, thermal stability, and dimensional strength.",
      "Electrode Industry – Enhances thermal performance and binding strength in coating formulations.",
   
    ],

    "packaging": [
      "Industry Focus: Ceramic Tile Industry",
      "Quality: Optimized for Superior Glaze Formulations",
      "Performance: Maximizes Production Output",
      "Supply Focus: Secure Your Supply Today"
    ],

    "delivery": {
      "availableForms": "Finely-Milled Powder",
      "supplyFocus": "Ceramic Tile, Frit, and Glaze Manufacturing Industries",
      "consistency": "Enhanced Na₂O Range with Consistent Particle Size",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Competitive / On Request",
      "deliveryTime": "7–10 Days",
      "storage": "Store in a moisture-free environment to retain composition"
    },

    "physicalfeatures": [
      "High-whiteness, ultra-fine powder with excellent dispersion",
      "High Na₂O content for superior fluxing efficiency",
      "Provides enhanced glaze brightness and smooth surface finish"
    ]
  },

  //14
  {
    "id": 14,
    "name": "Sodium Feldspar Powder SFP-110",
    "path": "/products/superior-grade-pure-white-mineral",
    "image": "/images/products/NewProductes/pure white mineral.png",

    "description": "This superior-grade pure white sodium feldspar mineral is meticulously selected for luxury ceramic and high-end glaze applications. Engineered with the lowest possible iron content, high sodium levels, and exceptional brightness, it delivers unmatched brilliance, transparency, and high-gloss finishes in premium ceramic, vitrified tile, and glass products.",

    "features": [
      "Optimized for Industrial Use",
      "Chemically Inert Material",
      "Excellent Melting Properties",
      "Fine Mesh Size: up to 500 mesh",
      "Low Iron & Titanium Impurities",
      "High Silica & Alumina Composition",
      "High Sodium Content",
    ],

    "specifications": [
      "SiO2: 65–80%",
      "Al2O3: 12–22%",
      "K2O: 1–2% Min",
      "Na2O: 10% Above",
      "Fe2O3: 0.5% Max",
      "CaO: 1% Max",
      "L > 85, a < 2, b < 5",
    ],

    "applications": [
      "Ceramic Industry – Used in tiles, sanitaryware, tableware, and porcelain to enhance strength, whiteness, and surface finish.",
      "Glass Industry – Serves as a flux to reduce melting temperature and improve clarity, hardness, and resistance.",
      "Glaze & Frit Industry – Produces glossy, smooth, and defect-free surfaces in glazes and enamels.",
      "Paint & Coating Industry – Enhances brightness, hardness, and durability in high-performance coatings.",
      "Plastic & Polymer Industry – Acts as a reinforcing filler for rigidity and thermal stability.",
      "Electrode Industry – Supports coating formulations for better bonding and high-temperature performance.",
    ],

    "packaging": [
      "Quality Standard: Superior-Grade",
      "Performance: Delivers Exceptional Brilliance",
      "Consistency: Reliable for Demanding Glazes",
      "Market Focus: Key to Luxury Ceramics"
    ],

    "delivery": {
      "availableForms": "Finely-Milled Powder",
      "supplyFocus": "Luxury Ceramic, Tile, and Glass Industries",
      "consistency": "Exceptional Brilliance and Reliable Composition",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Premium / On Request",
      "deliveryTime": "7–10 Days",
      "storage": "Store in a dry, clean area to preserve whiteness and chemical stability"
    },

    "physicalfeatures": [
      "Pure white appearance with exceptional brightness",
      "Lowest iron content ensures clarity and transparency",
      "Delivers high-gloss, aesthetic finishes in glazes and ceramics"
    ]
  },

  //15
  {
    "id": 15,
    "name": "Sodium Feldspar Chips ",
    "path": "/products/soda-feldspar-chips",
    "image": "/images/products/NewProductes/Soda Feldspar Chips.png",

    "description": "Sodium Feldspar Chips in superior granular form offer exceptional Na₂O and Al₂O₃ contributions for high-performance ceramic, glaze, frit, glass, and polymer applications. Designed for optimized vitrification, thermal stability, and predictable melt behavior, these chips ensure high whiteness, low impurities, and enhanced mechanical and thermal performance across industries.",

    "features": [
      "Uniform Grain Size",
      "Excellent Thermal Stability",
      "High Sodium Content",
      "Low Iron & Titanium Impurities",
      "High Silica & Alumina Levels",
      "Chemically Inert",
    ],

    "specifications": [
      "SiO2: 65–80%",
      "Al2O3: 12–22%",
      "K2O: 1–2% Min",
      "Na2O: 8.5% to 9%",
      "Fe2O3: 0.5% Max",
      "CaO: 1% Max",
      "L > 85, a < 2, b < 5",
     
    ],

    "applications": [
      "Ceramic Industry – Used in tiles, sanitaryware, and porcelain bodies to enhance strength, whiteness, and vitrification.",
      "Glass Industry – Acts as a flux to lower melting temperature and improve transparency and durability.",
      "Glaze & Frit Industry – Provides smooth, glossy finishes and higher surface hardness.",
      "Paint & Coating Industry – Improves brightness, scratch resistance, and coating stability.",
      "Plastic & Polymer Industry – Filler for improved strength and reduced shrinkage.",
      "Electrode Industry – Enhances binding and high-temperature performance in coating formulations.",
     
    ],

    "packaging": [
      "Form: Superior Granular Chips",
      "Handling: Clean, Free-Flowing",
      "Melt Behaviour: Predictable",
      "Production Impact: Boosts Kiln Efficiency"
    ],

    "delivery": {
      "availableForms": "Granular Chips",
      "supplyFocus": "Ceramic, Glass, and Vitrified Tile Industries",
      "consistency": "Clean, Low-Iron Composition with Predictable Melting",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Competitive / On Request",
      "deliveryTime": "7–10 Days",
      "storage": "Store in a dry environment to prevent moisture and maintain free-flowing quality"
    },

    "physicalfeatures": [
      "Clean, free-flowing granular texture",
      "Low-iron purity ensures flawless whiteness",
      "Predictable melt behavior improves kiln efficiency and yield"
    ]
  },

  //16
  {
    "id": 16,
    "name": "Dolomite Stone Lumps",
    "path": "/products/dolomite-lumps",
    "image": "/images/products/NewProductes/lump Dolomite.png",

    "description": "Dolomite Stone Lumps (CaMg(CO₃)₂) are high-purity, high-density mineral lumps used across ceramic, glass, steel, coating, agricultural, and construction industries. Known for their excellent whiteness, fluxing properties, chemical stability, and low impurity levels, these lumps deliver dual-element (Calcium & Magnesium) performance for strength, durability, and industrial efficiency.",

    "features": [
      "Good Fluxing Properties",
      "High Density & Hardness",
      "High Purity Composition",
      "Excellent Whiteness & Brightness",
      "High Chemical Stability",
      "Low Iron & Silica Content",
    ],

    "specifications": [
      "CaCO₃: 48–54%",
      "MgCO₃: 34–40%",
      "SiO₂: 1.5% (Max)",
      "Fe₂O₃: 0.3% (Max)",
      "Al₂O₃: 0.2% (Max)",
      "Loss on Ignition (LOI): 44–46%",
      "Whiteness (L): >90",
      "a: <1.5",
      "b: <3",
    ],

    "applications": [
      "Ceramic Industry – Used as a flux to improve whiteness, strength, and firing consistency.",
      "Glass Industry – Enhances durability, clarity, and melting efficiency.",
      "Steel & Metallurgical Industry – Acts as a flux to remove impurities and as a refractory material.",
      "Paint & Coating Industry – Adds brightness, opacity, and smoothness.",
      "Plastic & Rubber Industry – Improves hardness, dimensional stability, and strength.",
      "Agricultural Industry – Used as dolomitic lime to neutralize acidic soils and add nutrients.",
      "Construction Industry – Utilized as a building aggregate and in concrete mixes.",
      "Detergent Industry – Serves as a whitening agent and mild abrasive,improving texture and cleansing efficiency.",
    ],

    "packaging": [
      "Market Focus: Diverse High-Volume Markets",
      "Material Use: Indispensable Supply Chain Input",
      "Purity: High-Purity Commodity",
      "Sourcing: Imported Raw Lump Form"
    ],

    "delivery": {
      "availableForms": "Raw Lumps (10–80 mm)",
      "supplyFocus": "Construction, Steel, Leather, and Manufacturing Industries",
      "consistency": "Stable Ca–Mg Composition with Reliable Purity",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Competitive / On Request",
      "deliveryTime": "7–10 Days",
      "storage": "Store in a dry, covered area to prevent moisture absorption and maintain purity"
    },

    "physicalfeatures": [
      "White to off-white lumps with uniform texture",
      "Dual calcium and magnesium composition for balanced performance",
      "Low impurities and consistent bulk density"
    ]
  },

  //17
  {
    "id": 17,
    "name": "Calcium Carbonate (Calcite) Lumps ",
    "path": "/products/calcite-lumps",
    "image": "/images/products/NewProductes/Calcite Lumps.png",

    "description": "Calcite Lumps (Raw CaCO₃) are high-purity calcium carbonate minerals widely used as fillers, fluxes, and chemical precursors across industrial applications. With superior brightness, stability, and minimal impurities, these lumps form the backbone of plastics, paints, paper, steel, cement, construction materials, and environmental purification systems.",

    "features": [
      "High Purity (CaCO₃)",
      "Excellent Whiteness & Brightness",
      "High Density & Hardness",
      "Chemically Stable",
      "Versatile Grain Sizes",
      "Fluxing Properties",
    ],

    "specifications": [
      "CaCO₃: 96–99%",
      "MgCO₃: 0.5–2%",
      "SiO₂: 0.5% (Max)",
      "Fe₂O₃: 0.2% (Max)",
      "Al₂O₃: 0.1% (Max)",
      "Loss on Ignition (LOI): 43–44%",
      "Whiteness (L): >95",
      "a: <1.0",
      "b: <2.0",
    ],

    "applications": [
      "Ceramic Industry – Fluxing and filler material for tiles, sanitaryware, tableware, and insulators.",
      "Glass Industry – Provides calcium carbonate for fluxing, clarity, and durability in glass production.",
      "Paint & Coating Industry – Filler for brightness, opacity, smoothness, and chemical resistance.",
      "Plastic & Polymer Industry – Enhances rigidity, strength, surface finish, and dimensional stability.",
      "Detergent Industry – Whitening and buffering agent in soaps and detergents.",
      "Construction Industry – Used as aggregate, filler, and ingredient in cement and concrete.",
      "Agricultural Industry – Neutralizes soil acidity and supplies calcium.",
      "Rubber Industry – Improves elasticity, strength, and resistance to aging.",
      "Paper Industry – Enhances brightness, opacity, and smoothness of coated and uncoated papers.",
      "Chemical Industry – For manufacturing calcium salts, lime, and other chemical.",
      "Water Treatment Industry – Used for softening and neutralizing acidic water.",
      "Cosmetic Industry – Natural filler and whitening agent in powders and creams.",
    ],

    "packaging": [
      "Source Material: Raw CaCO₃ Lumps",
      "Secondary Function: Environmental Cleanup",
      "Applications: Flue Gas Desulfurization, Water Treatment",
      "Quality: Fundamental Industrial Bedrock",
      "Packaging Options: 25 kg Bags, 50 kg Bags, 1000/1250/1400 kg Jumbo Bags"
    ],

    "delivery": {
      "availableForms": "Raw Lumps (10–80 mm)",
      "supplyFocus": "Plastics, Paint, Steel, Cement, and Environmental Industries",
      "consistency": "High CaCO₃ Purity with Controlled Whiteness and Low Impurities",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Competitive / On Request",
      "deliveryTime": "7–10 Days",
      "storage": "Store in a dry area; avoid direct contact with moisture to maintain brightness"
    },

    "physicalfeatures": [
      "Pure white to snow-white lumps with high brightness",
      "Stable hardness (Mohs 3) and specific gravity (2.7)",
      "Low impurity levels ensuring consistent industrial performance",
      "Excellent fluxing and filler properties across multiple sectors"
    ]
  },

  //18
  {
    "id": 18,
    "name": "Quartz Powder",
    "path": "/products/quartz-powder-high-whiteness",
    "image": "/images/products/NewProductes/Premium Grade High-Whiteness Quartz Powder.png",

    "description": "Premium Grade High-Whiteness Quartz Powder is an ultra-fine, high-purity SiO₂ mineral engineered for advanced industrial applications requiring exceptional thermal stability, brightness, and low impurity content. With superior whiteness and extremely low iron levels, it is the preferred raw material for ceramics, premium coatings, glass, polymers, electronics, foundry, refractory, and semiconductor applications.",

    "features": [
      "Fine Particle Size: 500 mesh",
      "High Purity SiO₂",
      "Low Iron & Impurities",
      "Thermal Stability",
      "Chemically Inert",
      "Enhances Strength & Durability",
    ],

    "specifications": [
      "SiO₂: 98.5–99.8%",
      "Al₂O₃: 0.2–0.5%",
      "Fe₂O₃: 0.03–0.1% (Max)",
      "TiO₂: 0.05% (Max)",
      "CaO: 0.1% (Max)",
      "MgO: 0.1% (Max)",
      "Loss on Ignition (LOI): <0.5%",
      "Whiteness (L): >90",
      "a: <1.0",
      "b: <2.0",
    ],

    "applications": [
      "Ceramic Industry – Used in tiles, sanitaryware, and porcelain for whiteness, strength, and smooth surface finish.",
      "Glass Industry – Provides high-purity silica for glass, fiberglass, and specialty glass applications.",
      "Paint & Coating Industry – Acts as a filler to improve hardness, brightness, and durability.",
      "Plastic & Polymer Industry – Reinforcing filler that enhances rigidity, thermal stability, and smooth finish.",
      "Refractory Industry – Used in furnace linings, kilns, and heat-resistant materials.",
      "Foundry & Metallurgical Industry – Functions as a flux and refractory additive in metal casting and steelmaking.",
      "Chemical Industry – Raw material for silicon compounds, silicates, and other industrial chemicals.",
      "Abrasive Industry – Used in polishing, grinding, and sandblasting.",
      "Electronics & Semiconductor Industry – High-purity quartz powder is used in silicon wafers, optical fibers, and electronic components.",
      "Construction Industry – Used in concrete, mortar, and decorative stone products.",
      "Water Filtration & Treatment Industry – Quartz powder is used in filtration media for water purification.",
      "Adhesives & Sealants Industry – Provides strength and thermal stability to adhesives and sealants.",
    ],

    "packaging": [
      "Market Focus: Key International Markets",
      "Certification: Certificate of Analysis Confirmed",
      "Performance: High-Quality, Non-Yellowing, Durable",
      "Grade: Premium Export Mineral"
    ],

    "delivery": {
      "availableForms": "Fine Powder (200# / 300# / 400# / 500#)",
      "supplyFocus": "Ceramics, Glass, and Premium Coating Industries",
      "consistency": "High Whiteness and Ultra-Low Iron Content for Export-Grade Applications",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Premium Export Pricing / On Request",
      "deliveryTime": "7–10 Days",
      "storage": "Store in a dry, clean environment to preserve whiteness and prevent contamination"
    },

    "physicalfeatures": [
      "White to off-white fine powder with superior brightness",
      "High-purity SiO₂ ensuring optical and thermal stability",
      "Extremely low Fe₂O₃ content for non-yellowing properties",
      "Excellent dispersibility and consistency across production batches"
    ]
  }
  ,

  //19
  {
    "id": 19,
    "name": "Ball Clay BK-1",
    "path": "/products/ball-clay-bk1",
    "image": "/images/products/NewProductes/BK-1L Grade Ball Clay.png",

    "description": "BK-1L Grade Ball Clay is a high-performance ceramic binder known for its exceptional plasticity, fine particle size, high refractoriness, and superior unfired (green) strength. Specially processed for use in premium whiteware bodies, sanitaryware, tiles, and tableware, it ensures outstanding shaping performance and excellent light-firing color.",

    "features": [
      "Excellent Water Absorption",
      "High Plasticity",
      "Fine Particle Size",
      "Good Firing Strength",
      "Low Impurities",
      "High Refractoriness",
    ],

    "specifications": [
      "L Value: 72% Min",
      "Moisture: 9% Max",
      "CaO: 2% Max",
      "MgO: 2% Max",
      "CaO: 4% Max",
    ],

    "applications": [
      "Ceramic Industry – Used in tiles, sanitaryware, tableware, porcelain, and pottery for plasticity, strength, and smooth surface finish.",
      "Refractory Industry – Acts as a binder and plastic material in firebricks and kiln linings..",
      "Sanitaryware Industry – Provides workability and whiteness for sinks, toilets, and bathroom fittings.",
      "Tile Industry – Improves plasticity, surface smoothness, and firing performance of ceramic tiles.",
      "Pottery & Artware Industry – Used for molding, shaping, and fine detailing of pottery items.",
      "Porcelain Industry – Enhances whiteness, strength, and fine texture in porcelain bodies.",
      "Cement & Construction Industry – Sometimes used as a filler or additive in specialized cements and bricks.",
      "Refractories & Insulation Products – Provides plasticity and thermal stability in high-temperature applications.",
      "Glass Industry – Occasionally used as a minor additive to improve ceramic-to-glass interfaces or in specialty glass formulations.",
    ],

    "packaging": [
      "Grade: BK-1L Grade Ball Clay",
      "Performance: High-Performance Binder",
      "Goal: Maximizing Production Yield",
      "Consistency: Consistent, Reliable Supply"
    ],

    "delivery": {
      "availableForms": "Fine Raw Clay (Moist / Dried Powder Form)",
      "supplyFocus": "Sanitaryware, Tile, and Tableware Industries",
      "consistency": "Stable Plasticity and Fine Particle Distribution",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Competitive / On Request",
      "deliveryTime": "7–10 Days",
      "storage": "Store in a covered, dry area to retain moisture balance and prevent contamination"
    },

    "physicalfeatures": [
      "Cream to light-grey fine clay material",
      "Excellent plasticity for shaping and forming",
      "Bright light-firing color suitable for whiteware bodies",
      "Superior green strength reducing breakage during processing"
    ]
  },

  //20
  {
    "id": 20,
    "name": "Ball Clay PC-1",
    "path": "/products/ball-clay-pc1",
    "image": "/images/products/NewProductes/high-plasticity grade.png",

    "description": "Ball Clay PC-1 is a super-fine, high-plasticity premium grade engineered for sanitaryware, porcelain, tiles, and all high-quality ceramic whiteware. Its ultra-refined particle size provides exceptional binding, excellent casting behavior, superior unfired strength, and a bright white-firing finish essential for premium ceramic bodies.",

    "features": [
      "Fine Particle Size - upto 500 Mesh",
      "Low Impurities",
      "Good Firing Strength",
      "High Refractoriness",
      "Excellent Water Retention",
      "High Plasticity",
      "Optimized for Industrial Use",
    ],

    "specifications": [
      "SiO₂: 60% Min",
      "Al₂O₃: 25% Min",
      "Fe₂O₃: 1.5% Max",
      "TiO₂: 2.5% Max",
    ],

    "applications": [
      "Ceramic Industry – Used in tiles, porcelain, tableware, and pottery for plasticity, smooth surface, and firing strength.",
      "Sanitaryware Industry – Provides superior whiteness, plasticity, and strength for sinks, toilets, and bathroom fittings.",
      "Tile Industry – Enhances plasticity, surface smoothness, and firing performance in ceramic tiles.",
      "Pottery & Artware – Ideal for molding, shaping, and fine detailing.",
      "Porcelain Industry – Improves whiteness, texture, and strength in porcelain products.",
      "Pottery & Artware Industry – Ideal for molding, shaping, and fine detailing of pottery and artware items.",
      "Refractory Industry – Acts as a plastic binder for firebricks, kiln linings, and insulation materials.",
      "Cement & Construction Industry – Used as a filler or additive in specialty bricks and cement formulations.",
      "Glass Industry – Occasionally used as a minor additive in specialty glass or ceramic-to-glass interfaces.",
    ],

    "packaging": [
      "Grade: PC-1 Super-Fine Ball Clay",
      "Performance: High-Plasticity Binder and Casting Clay",
      "Quality Focus: Refined for Color Fidelity and Strength",
      "Goal: Achieve Bright White, High-Strength Ceramic Bodies"
    ],

    "delivery": {
      "availableForms": "Fine Powder (300 Mesh)",
      "supplyFocus": "Sanitaryware, Tile, and Porcelain Manufacturing",
      "consistency": "High Plasticity with Ultra-Fine Particle Size and Color Purity",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Competitive / On Request",
      "deliveryTime": "7–10 Days",
      "storage": "Store in a dry and shaded area to maintain plasticity and prevent contamination"
    },

    "physicalfeatures": [
      "Off-white to cream fine powder with smooth texture",
      "High plasticity enabling detailed molding and casting",
      "Super-fine particle size for dense, cohesive ceramic bodies",
      "Bright white-firing color for premium aesthetics"
    ]
  },

  //21
  {
    "id": 21,
    "name": "Kaolin Clay AG-1",
    "path": "/products/kaolin-clay-ag1",
    "image": "/images/products/NewProductes/Kaolin clayBK-1L Grade Ball Clay.png",

    "description": "AG-1 Grade Kaolin Clay is a refined high-brightness white mineral engineered to deliver superior whiteness, plasticity, and particle consistency for premium ceramic applications. With its excellent molding behavior, light-firing color, and stable green strength, AG-1 is a trusted raw material for sanitaryware, tiles, porcelain, tableware, and other high-quality whiteware industries.",

    "features": [
      "Optimal Water of Plasticity",
      "High L Value (Whiteness)",
      "High Whiteness",
      "Fine Particle Size & Consistency",
      "Low Impurities",
      "High Refractoriness",
    ],

    "specifications": [
      "L Value: 92% Min",
      "Water of Plasticity: 35–40%",
      "Whiteness: 80+",
    ],

    "applications": [
      "Ceramic Industry – Used in tiles, sanitaryware, tableware, and porcelain for whiteness, plasticity, and smooth surface finish.",
      "Paper Industry – Acts as a coating and filler to improve brightness, opacity, smoothness, and printability of papers.",
      "Paint & Coating Industry – Provides whiteness, opacity, and smooth texture in paints and coatings.",
      "Rubber Industry – Serves as a filler to improve elasticity, strength, and abrasion resistance.",
      "Plastic & Polymer Industry – Enhances rigidity, surface finish, and dimensional stability.",
      "Refractory Industry – Provides thermal stability and plasticity in high-temperature applications.",
      "Ceramic & Porcelain Tile Industry – Enhances whiteness, smoothness, and workability.",
      "Adhesives & Sealants Industry – Acts as a filler to improve consistency, texture, and bonding properties.",
      "Cosmetic Industry – Used as a natural filler and whitening agent in powders and creams.",
    ],

    "packaging": [
      "Grade: AG-1 Kaolin Clay",
      "Performance: High-Brightness Ceramic Raw Material",
      "Goal: Consistent Color and Strength in Whiteware",
      "Quality Control: Processed for Uniform Whiteness and Plasticity"
    ],

    "delivery": {
      "availableForms": "Refined Clay Powder",
      "supplyFocus": "Ceramic, Tile, and Sanitaryware Manufacturing",
      "consistency": "High whiteness and controlled plasticity for reliable performance",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Competitive / On Request",
      "deliveryTime": "7–10 Days",
      "storage": "Store in a covered, dry area to prevent moisture absorption and preserve brightness"
    },

    "physicalfeatures": [
      "Soft white fine clay with smooth texture",
      "Excellent plasticity for molding, casting, and fine detailing",
      "High whiteness with light-firing color quality",
      "Stable moisture retention and superior green strength"
    ]
  },

  //22
  {
    "id": 22,
    "name": "Washed Blended Kaolin: CCA (A Grade)",
    "path": "/products/washed-blended-kaolin-cca",
    "image": "/images/products/NewProductes/Washed Blended Kaolin.png",

    "description": "This premium Washed Blended Kaolin (CCA – A Grade) is a high-purity, low-impurity refined kaolin engineered for superior performance in high-precision ceramic, coating, paper, and polymer applications. Its fine particle size, excellent plasticity, and high whiteness ensure dimensional stability, smooth surface finish, and reliable performance across industries.",

    "specifications": [
      "Dry MOR: 10% Min",
      "Water Absorption: 15% Max",
      "Total Shrinkage: 10–15%",
    ],

    "features": [
      "High Purity & Low Impurities",
      "Fine Particle Size & Exceptional Consistency",
      "High Whiteness & Strong L Value",
      "Good Plasticity & Workability",
      "Chemically Stable & Inert",
    ],

    "applications": [
      "Ceramic Industry – Used in tiles, sanitaryware, tableware, and porcelain for whiteness, plasticity, and smooth surface finish.",
      "Paper Industry – Acts as a coating and filler to improve brightness, opacity, smoothness, and printability of papers.",
      "Paint & Coating Industry – Provides whiteness, opacity, and smooth texture in paints and coatings.",
      "Rubber Industry – Serves as a filler to improve elasticity, strength, and abrasion resistance.",
      "Plastic & Polymer Industry – Enhances rigidity, surface finish, and dimensional stability.",
      "Refractory Industry – Provides thermal stability and plasticity in high-temperature applications.",
      "Ceramic & Porcelain Tile Industry – Enhances whiteness, smoothness, and workability.",
      "Adhesives & Sealants Industry – Acts as a filler to improve consistency, texture, and bonding properties.",
      "Cosmetic Industry – Used as a natural filler and whitening agent in powders and creams.",
    ],

    "packaging": [
      "Quality Classification: Washed Blended Kaolin – CCA (A Grade)",
      "High Whiteness & Consistency Guaranteed",
      "Engineered for Dimensional Stability & Smooth Finish",
      "Refined, Washed, & Blended for Superior Uniformity"
    ],

    "delivery": {
      "availableForms": "Washed & Blended Refined Kaolin Powder",
      "supplyFocus": "Ceramics, Paper, Paints, Polymers, Rubber & Cosmetic Industries",
      "consistency": "High Whiteness, Fine Particle Size & Controlled Plasticity",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Premium / On Request",
      "deliveryTime": "7–10 Days",
      "storage": "Store in a cool, dry area to prevent rehydration and maintain powder flow"
    },

    "physicalfeatures": [
      "Bright white refined kaolin powder",
      "Fine, smooth particle structure",
      "High dry strength with controlled firing shrinkage",
      "Low fired porosity for dense & durable final products",
      "Excellent uniformity for predictable performance"
    ]
  },

  //23
  {
    "id": 23,
    "name": "Washed Blended Kaolin CC2A (AA-Grade)",
    "path": "/products/washed-blended-kaolin-cc2a",
    "image": "/images/products/NewProductes/premium Washed Blended Kaolin.png",

    "description": "The CC2A 'AA-Grade' Washed Blended Kaolin is an ultra-refined, premium-quality kaolin engineered for high-precision ceramic, porcelain, refractory, and industrial applications. With superior purity, controlled shrinkage, high green strength, and exceptional fired whiteness, this material ensures dimensional accuracy and high performance across complex ceramic manufacturing processes.",

    "specifications": [
      "Dry MOR: 10% Min ",
      "Water Absorption : 15% Max",
      "Total Shrinkage: 10–15%",
    ],

    "features": [
      "High Purity & Superior Whiteness",
      "Controlled Dry Moisture & Low Water Absorption",
      "Fine Particle Size & Exceptional Uniformity",
      "Good Plasticity & Workability",
      "High Strength and Low Porosity",
      "Chemically Stable & Inert",
    ],

    "applications": [
      "Ceramic Industry – Used in tiles, sanitaryware, tableware, and porcelain for whiteness, plasticity, and smooth surface finish.",
      "Paper Industry – Acts as a coating and filler to improve brightness, opacity, smoothness, and printability.",
      "Paint & Coating Industry – Provides whiteness, opacity, smooth texture, and hiding power in paints and coatings.",
      "Rubber Industry – Serves as a reinforcing filler to improve elasticity, strength, and abrasion resistance.",
      "Plastic & Polymer Industry – Enhances rigidity, surface finish, and dimensional stability in polymers and composites.",
      "Refractory Industry – Provides thermal stability and plasticity in high-temperature applications like kiln linings and firebricks.",
      "Adhesives & Sealants Industry – Acts as a filler to improve consistency, bonding, and texture.",
      "Cosmetic Industry – Used as a natural filler, brightener, and texturizer in powders, creams, and personal care products.",
      "Ceramic & Porcelain Tile Industry – Enhances whiteness, workability, and smooth surface finish.",
      "Paint Pigments Industry – Used in the formulation of specialty coatings and pigment extenders.",
    ],

    "packaging": [
      "Available Packaging: 25 kg Bags, 50 kg Bags, 1000/1250/1400 kg Jumbo Bags",
      "Premium AA-Grade Classification",
      "Processed for uniform whiteness and controlled shrinkage",
      "Suitable for high-precision and high-performance ceramic applications"
    ],

    "delivery": {
      "availableForms": "Washed & Blended Refined Kaolin Powder",
      "supplyFocus": "Ceramic, porcelain, refractory, paper, paint & polymer industries",
      "consistency": "High purity, controlled plasticity & predictable firing behavior",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Premium / On Request",
      "deliveryTime": "7–10 Days",
      "storage": "Store in a cool, dry area to avoid moisture absorption and maintain powder flow"
    },

    "physicalfeatures": [
      "Bright white fine kaolin powder",
      "High dry strength for safe greenware handling",
      "Low fired porosity ensuring dense final ceramics",
      "Fine and uniform particle structure",
      "Excellent smoothness and whiteness after firing",
      "Chemically inert and thermally stable"
    ]
  },

  //24
  {
    "id": 24,
    "name": "Fire Clay CM-1 Gitti (Refractory Grade)",
    "path": "/products/fire-clay-cm1-gitti",
    "image": "/images/products/NewProductes/Refractory clay.png",

    "description": "Fire Clay CM-1 Gitti is a refractory-grade ceramic raw material enriched with alumina and silica. Engineered to withstand extreme temperatures, it delivers high thermal stability, excellent fired strength, and structural integrity-making it the essential base material for firebricks, kiln linings, and high-temperature industrial applications.",

    "specifications": [
      "Water Plasticity: 40+",
      "L Value (Whiteness): 90+",
      "Fired MOR: 325+",
    ],

    "features": [
      "High Water Plasticity",
      "High L Value ",
      "High Fired MOR",
      "Outstanding Refractoriness & Thermal Stability",
      "Low Impurities",
      "Uniform Particle Size",
    ],

    "applications": [
      "Refractory & Insulation Industry – Used in firebricks, kiln linings, and high-temperature insulation products.",
      "Ceramic Industry – Acts as a flux and filler in ceramic bodies for tiles, sanitaryware, and tableware. ",
      "Bricks & Construction Industry – Used in manufacturing refractory and high-strength bricks.",
      "Steel & Metallurgical Industry – Provides refractory lining material for furnaces, ladles, and other high-temperature applications.",
      "Glass Industry – Used in furnace linings and ceramic parts exposed to high heat.",
      "Cement & Lime Industry – Acts as a refractory additive in kilns and high-temperature processes.",
      "Ceramic & Porcelain Tile Industry – Enhances firing performance, whiteness, and strength of tiles"
    ],

    "packaging": [
      "Available Packaging: 25 kg Bags, 50 kg Bags, 1000/1250/1400 kg Jumbo Bags",
      "Grade: CM-1 Gitti Fire Clay",
      "Material Type: Refractory Ceramic Clay",
      "Performance: High Heat Resistance & Structural Durability",
      "Industry Use: Core Raw Material for Refractory Manufacturing"
    ],

    "delivery": {
      "availableForms": "Lumps / Gitti Form",
      "supplyFocus": "Refractory, Steel, Glass, Cement & Construction Industries",
      "consistency": "High Alumina–Silica Composition with Controlled Plasticity",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Competitive / On Request",
      "deliveryTime": "7–10 Days",
      "storage": "Store in a dry, shaded area to prevent moisture absorption and preserve refractory performance"
    },

    "physicalfeatures": [
      "Coarse gitti-like clay material, grayish to off-white",
      "High alumina–silica content ensuring excellent refractoriness",
      "Maintains structural integrity at elevated temperatures",
      "Suitable for creating durable firebricks and furnace linings",
      "Stable thermal and mechanical performance"
    ]
  },

  //25
  {
    "id": 25,
    "name": "Fire Clay BT-01 Gitti",
    "path": "/products/fire-clay-bt01-gitti",
    "image": "/images/products/NewProductes/Fire Clayknown as BT-01 GittiWater.png",

    "description": "Fire Clay BT-01 Gitti is a premium refractory-grade clay engineered for high-temperature ceramic and industrial applications. Known for its exceptional plasticity, bright fired color, and high fired MOR, this material is ideal for forming complex refractory shapes and producing durable, heat-resistant components.",

    "specifications": [
      "Water Plasticity: 40+",
      "L Value: 90+",
      "Fired MOR: 325+",
    ],

    "features": [
      "High Water Plasticity",
      "High L Value",
      "High Fired MOR",
      "Low Impurities",
      "Fine Particle Consistency",
      "Refractoriness & Thermal Stability"
    ],

    "applications": [
      "Refractory & Insulation Industry – Used in firebricks, kiln linings, and high-temperature insulation products.",
      "Ceramic Industry – Acts as a flux and filler in ceramic bodies for tiles, sanitaryware, and tableware. ",
      "Bricks & Construction Industry – Used in manufacturing refractory and high-strength bricks.",
      "Steel & Metallurgical Industry – Provides refractory lining material for furnaces, ladles, and other high-temperature applications.",
      "Glass Industry – Used in furnace linings and ceramic parts exposed to high heat.",
      "Cement & Lime Industry – Acts as a refractory additive in kilns and high-temperature processes.",
      "Ceramic & Porcelain Tile Industry – Enhances firing performance, whiteness, and strength of tiles",
    ],

    "packaging": [
      "Grade: BT-01 Gitti Fire Clay",
      "Material Type: Premium Refractory Clay",
      "Performance: High Plasticity and Exceptional Fired Strength",
      "Packaging Options: 25 kg Bags, 50 kg Bags, 1000/1250/1400 kg Jumbo Bags",
      "Focus: Ideal for advanced refractory and high-temperature forming applications"
    ],

    "delivery": {
      "availableForms": "Lumps / Gitti Form",
      "supplyFocus": "Refractory, Steel, Glass, Ceramics, Cement, and Construction Industries",
      "consistency": "High Plasticity, Bright Fired Color, Stable Thermal Resistance",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Premium / On Request",
      "deliveryTime": "7–10 Days",
      "storage": "Store in a dry, shaded area to maintain plasticity and avoid moisture absorption"
    },

    "physicalfeatures": [
      "Coarse, bright off-white refractory clay material",
      "Excellent shaping and molding capability due to superior plasticity",
      "High fired strength with minimal deformation under extreme heat",
      "Clean-burning, light-firing color ideal for performance-critical refractory components",
      "Stable thermal and mechanical performance across repeated heating cycles"
    ]
  },

  //26
  {
    "id": 26,
    "name": "Fire Clay GE-03",
    "path": "/products/fire-clay-ge03",
    "image": "/images/products/NewProductes/premium-grade clay.png",

    "description": "Fire Clay GE-03 is a premium refractory-grade material engineered for demanding high-temperature applications. With its high plasticity, excellent refractoriness, and strong fired mechanical strength, it is widely used in the refractory, metallurgical, ceramic, and construction industries. Its low impurities and consistent particle quality ensure stable performance across multiple firing cycles.",

    "specifications": [
      "Water Plasticity: 40+",
      "L Value: 90+",
      "Fired MOR: 325+",
    ],

    "features": [
      "High Plasticity",
      "Good Refractoriness",
      "High Fired Mechanical Strength",
      "Low Impurities",
      "Consistent Particle Size & Quality",
    ],

    "applications": [
      "Refractory & Insulation Industry – Used in firebricks, kiln linings, and high-temperature insulation products.",
      "Ceramic Industry – Acts as a flux and filler in ceramic bodies for tiles, sanitaryware, and tableware. ",
      "Bricks & Construction Industry – Used in manufacturing refractory and high-strength bricks.",
      "Steel & Metallurgical Industry – Provides refractory lining material for furnaces, ladles, and other high-temperature applications.",
      "Glass Industry – Used in furnace linings and ceramic parts exposed to high heat.",
      "Cement & Lime Industry – Acts as a refractory additive in kilns and high-temperature processes.",
      "Ceramic & Porcelain Tile Industry – Enhances firing performance, whiteness, and strength of tiles"
    ],

    "packaging": [
      "Grade: GE-03 Fire Clay",
      "Material Type: Premium Refractory Clay",
      "Packaging Options: 25 kg Bags, 50 kg Bags, 1000/1250/1400 kg Jumbo Bags",
      "Performance: High Plasticity, High Fired Strength, Low Impurities",
      "Application Focus: Refractory, Kiln Linings, High-Temperature Structural Components"
    ],

    "delivery": {
      "availableForms": "Lumps / Gitti Form",
      "supplyFocus": "Refractory, Steel, Cement, Ceramic, and High-Temperature Industries",
      "consistency": "Stable Particle Quality, High Plasticity, and Strong Fired MOR",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Premium / On Request",
      "deliveryTime": "7–10 Days",
      "storage": "Store in a dry, shaded area to preserve plasticity and prevent moisture absorption"
    },

    "physicalfeatures": [
      "Bright off-white to white refractory clay",
      "High plasticity suitable for shaping complex refractory parts",
      "Excellent thermal stability under continuous heating",
      "Strong, dense fired body with low porosity",
      "Low impurities for clean, bright firing result"
    ]
  },

  //27
  {
    "id": 27,
    "name": "Talc Lumps TKY Grade",
    "path": "/products/talc-lumps-tky",
    "image": "/images/products/NewProductes/talc lumps.png",

    "description": "These Talc Lumps (TKY Grade) are a high-purity, premium industrial mineral known for their exceptionally low calcium oxide (CaO) content, high magnesium oxide (MgO) levels, and excellent whiteness. With superior chemical inertness and consistent performance, they remain a preferred raw material across global ceramic, plastic, paint, rubber, and specialty industries.",

    "specifications": [
      "CaO: 2% Max",
      "MgO: 28% Min",
      "Water Absorption: 15% Max",
      "L Value: 85% Min",
    ],

    "features": [
      "High Magnesium Content",
      "Low Calcium Content (CaO)",
      "Low Water Absorption",
      "High Whiteness & Brightness",
      "Fine, Uniform Lumps",
      "Chemically Inert and Stable"
    ],

    "applications": [
      "Ceramic Industry – Acts as a flux and filler to improve whiteness, thermal stability, and smoothness in tiles, sanitaryware, and tableware",
      "Glass Industry – Functions as a stabilizer and filler in specialty glass and ceramics",
      "Paint & Coating Industry – Provides brightness, opacity, smooth texture, and durability",
      "Plastic & Polymer Industry – Serves as a reinforcing filler improving rigidity, dimensional stability, and surface finish",
      "Paper Industry – Enhances brightness, opacity, smoothness, and printability",
      "Cosmetic Industry – Used as a natural filler, brightener, and texturizer in powders, creams, and personal care products",
      "Rubber Industry – Improves elasticity, strength, abrasion resistance, and processing performance",
      "Refractory Industry – Contributes thermal stability and durability to refractory bricks and kiln linings, and high-temperature applications",
      "Ceramic & Porcelain Tile Industry – Enhances whiteness, plasticity, and firing performance",
      "Adhesives & Sealants Industry – Improves consistency, bonding, and texture",
      "Pharmaceutical Industry – Functions as an inert filler and anti-caking agent",
      "Food Industry – Used as an anti-caking agent or processing aid in certain applications."
    ],

    "packaging": [
      "Grade: TKY Talc Lumps (High-Purity Industrial Grade)",
      "Material Type: Natural Hydrated Magnesium Silicate",
      "Packaging Options: 25 kg Bags, 50 kg Bags, 1000/1250/1400 kg Jumbo Bags",
      "Performance: High MgO Purity, Low CaO, and Controlled Whiteness",
      "Industry Focus: Ceramics, Paint, Plastics, Rubber, Cosmetics, and Specialty Applications"
    ],

    "delivery": {
      "availableForms": "Lumps (Custom-Sized on Request)",
      "supplyFocus": "Ceramics, Paint, Plastics, Rubber, Paper, Cosmetic, and Specialty Industries",
      "consistency": "High Whiteness, Low CaO, and Stable Chemical Composition",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Competitive / On Request",
      "deliveryTime": "7–10 Days",
      "storage": "Store in a dry, dust-free environment to preserve whiteness and prevent contamination"
    },

    "physicalfeatures": [
      "Off-white to light-gray soft lumps with fine lamellar structure",
      "High MgO content ensures superior chemical purity and stability",
      "Excellent smoothness, lamellar texture, and dispersibility during processing",
      "Maintains whiteness, stability, and consistency across industrial applications"
    ]
  },

  //28
  {
    "id": 28,
    "name": "Talc Lumps TKW Grade",
    "path": "/products/talc-lumps",
    "image": "/images/products/NewProductes/TalcLumps.png",

    "description": "These Talc Lumps (TKW Grade) are a premium, export-ready mineral known for exceptional chemical purity, high MgO, extremely low CaO, and superior whiteness. With excellent lamellar structure, chemical inertness, and high brightness, this grade is widely preferred across plastics, paints, paper, cosmetics, ceramics, and specialty industries.",

    "specifications": [
      "CaO: 2% Max",
      "MgO: 28% Min",
      "Water Absorption: 15% Max",
      "L Value: 90% Min",
    ],

    "features": [
      "High Purity Grade", 
      "Lubricating & Anti-Caking Properties",
      "Excellent Thermal Stability",
      "Fine and Uniform Lumps",
      "Chemically Inert & Stable",
      "High Whiteness",
      "Low Water Absorption",
      "Low Calcium Content",
      "High Magnesium Content",
    ],

    "applications": [
      "Ceramic Industry – Acts as a flux and filler to improve whiteness, thermal stability, and surface smoothness in tiles, sanitaryware, and tableware.",
      "Glass Industry – Used as a stabilizer and filler in specialty glass and ceramics.",
      "Paint & Coating Industry – Provides brightness, smooth texture, opacity, and durability in paints and coatings.",
      "Plastic & Polymer Industry – Reinforcing filler to improve rigidity, dimensional stability, surface finish, and thermal resistance.",
      "Paper Industry – Enhances brightness, opacity, smoothness, and printability in coated and uncoated papers.",
      "Cosmetic Industry – Natural filler, brightener, and texturizer in powders, creams, and personal care products.",
      "Rubber Industry – Improves elasticity, strength, abrasion resistance, and processability.",
      "Refractory Industry – Adds thermal stability and durability in refractory bricks, kiln linings, and high-temperature applications.",
      "Ceramic & Porcelain Tile Industry – Enhances whiteness, plasticity, and firing performance of tiles.",
      "Adhesives & Sealants Industry – Serves as a filler to improve consistency, bonding, and texture.",
      "Pharmaceutical Industry – Used as an inactive filler, anti-caking agent, or excipient in formulations.",
      "Food Industry – Serves as an anti-caking agent or processing aid in specific applications.",
      "Specialty Chemicals Industry – Used as a functional filler or additive in chemical formulations.",
    ],

    "packaging": [
      "Grade: TKW Premium Export Grade Talc Lumps",
      "Material Type: Natural Hydrated Magnesium Silicate",
      "Packaging Options: 25 kg Bags, 50 kg Bags, 1000/1250/1400 kg Jumbo Bags",
      "Quality Promise: High MgO, Low CaO, High Whiteness",
      "Market Focus: Plastics, Paint, Paper, Cosmetics, Ceramics, and Global Industrial Applications"
    ],

    "delivery": {
      "availableForms": "Lumps (Custom Sizing Available)",
      "supplyFocus": "Plastics, Paint, Paper, Ceramic, Rubber, Cosmetic, and Specialty Chemical Industries",
      "consistency": "High Whiteness, Low Impurities, and Controlled Moisture Content",
      "minimumOrderQuantity": "25 Tons",
      "pricing": "Competitive Export Pricing / On Request",
      "deliveryTime": "7–10 Days",
      "storage": "Store in a clean, dry area to maintain whiteness, prevent moisture absorption, and avoid contamination"
    },

    "physicalfeatures": [
      "Soft, silky lamellar lumps with high brightness",
      "Chemically inert and thermally stable under processing conditions",
      "Excellent dispersibility and reinforcing behavior in polymers and coatings",
      "Maintains whiteness, smoothness, and color accuracy across final applications"
    ]
  },

];

// Helper function to get product by ID
export const getProductById = (id: number): Product | undefined => {
  return productList.find(product => product.id === id);
};

// Helper function to get product by path
export const getProductByPath = (path: string): Product | undefined => {
  return productList.find(product => product.path === path);
};

// Helper function to get all product names for navigation
export const getProductNames = (): Array<{ id: number; name: string; path: string }> => {
  return productList.map(product => ({
    id: product.id,
    name: product.name,
    path: product.path
  }));
};